module.exports = __webpack_public_path__ + "img/维达-1.22be3b7f.png";